import React from 'react';
import './MacroEventsIcon.css';

// Kalender-Icon in der globalen Top-Navigation (in JEDEM Modul sichtbar,
// Chat vom 2026-08-12). Wird ROT, wenn heute wichtige US-Makrotermine anstehen.
// Liest den vom Cron-Fetch (fredMacroFetch.php -> Redis) gefuellten Cache ueber
// die Read-Task MarketdataMacroEvents. Da die Daten frei verfuegbar sind (FRED),
// laeuft das Icon in ALLEN Instanzen - die Read-Task haengt bewusst NICHT am
// Marktdaten-Lizenzgate (siehe MarketdataMacroEvents.inc). Klick oeffnet einen
// Hinweis-Dialog (x.wah.addHint) mit heutigen und kommenden Terminen.
function MacroEventsIcon({ x }) {
	const [data, setData] = React.useState(null);

	const load = React.useCallback(() => {
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=MarketdataMacroEvents', {}, (result) => {
			if (result.data.returncode === 1) {
				setData(result.data.content);
			}
		});
	}, [x]);

	React.useEffect(() => {
		load();
		// Termine aendern sich hoechstens 1x taeglich; stuendlich reicht, damit
		// der Tageswechsel (heute-Liste) ohne Neuladen nachzieht.
		const timer = setInterval(load, 3600000);
		return () => clearInterval(timer);
	}, [load]);

	if (data === null) {
		return null;
	}

	const today = Array.isArray(data.today) ? data.today : [];
	const upcoming = Array.isArray(data.upcoming) ? data.upcoming : [];

	// Gar keine Daten (Cache leer, z.B. Fetch noch nie gelaufen) -> kein Icon.
	if (today.length === 0 && upcoming.length === 0) {
		return null;
	}

	function formatDate(d) {
		const parts = String(d).split('-');
		return parts.length === 3 ? parts[2] + '.' + parts[1] + '.' : d;
	}

	function showDialog() {
		const body = (
			<div className="macro-events-hint">
				<div className="macro-events-hint-title">Wichtige US-Termine</div>
				{today.length > 0 && (
					<div className="macro-events-hint-group">
						<div className="macro-events-hint-group-label">Heute</div>
						{today.map((e, i) => (
							<div className="macro-events-hint-row" key={'t' + i}>
								<span className="macro-events-hint-time">{e.time}</span>
								<span className="macro-events-hint-name">{e.name}</span>
							</div>
						))}
					</div>
				)}
				{upcoming.length > 0 && (
					<div className="macro-events-hint-group">
						<div className="macro-events-hint-group-label">Kommende Termine</div>
						{upcoming.map((e, i) => (
							<div className="macro-events-hint-row" key={'u' + i}>
								<span className="macro-events-hint-date">{formatDate(e.date)}</span>
								<span className="macro-events-hint-time">{e.time}</span>
								<span className="macro-events-hint-name">{e.name}</span>
							</div>
						))}
					</div>
				)}
				<div className="macro-events-hint-source">Quelle: FRED (St. Louis Fed) · Zeiten Europe/Berlin</div>
			</div>
		);
		x.wah.addHint(body, false);
	}

	const hasToday = today.length > 0;

	return (
		<i
			className={'bi bi-calendar-event navigation-icon macro-events-icon' + (hasToday ? ' macro-events-icon-today' : '')}
			title={hasToday ? 'Heute wichtige US-Termine' : 'Kommende US-Termine'}
			onClick={showDialog}
		/>
	);
}

export default MacroEventsIcon;
